import { useEffect } from 'react';
import { useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import { useParams } from 'react-router-dom';
import APIService from '../../../Services/APIService';
export default function CommonPricingDetails({ code }) {
  const { id } = useParams();
  const [pricingData, setPricingData] = useState([]);

  const getPricing = async () => {
    let res = await APIService.get(`${ANG_APIS.GET_PRICING}${id}/basic_pricing/?supplierTypeCode=${code}`);
    if (res.status == 200)
      setPricingData(res.prices);
  };

  const postPricing = async () => {
    let res = await APIService.post(`${ANG_APIS.GET_PRICING}${id}/basic_pricing/`, pricingData)
    if (res.status == 200)
      console.log(res);
  };

  useEffect(() => {
    getPricing();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    postPricing();
  };

  return (
    <div>
      <table className="table-data">
        <thead>
          <th>AdInventory Name</th>
          <th>Type</th>
          <th>(Campaign/Unit) Duration</th>
          <th>Suggested Supplier Price</th>
          <th>Actual Supplier Price</th>
        </thead>
        <tbody>
          {pricingData.length > 0 &&
            pricingData.map((row, key) => {
              return (
                <tr ng-repeat="row in model" ng-hide="!row.duration_type" key={key}>
                  <td>
                    <span>{row?.adinventory_type?.adinventory_name}</span>
                  </td>
                  <td>
                    <span>{row?.adinventory_type?.adinventory_type}</span>
                  </td>
                  <td>
                    <span>{row?.duration_type?.duration_name}</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      ng-change="auto_change(row)"
                      value={row?.suggested_supplier_price}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      ng-change="auto_change(row)"
                      value={row?.actual_supplier_price}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
      <input type="button" className="smallBtn" onClick={handleSubmit} value="Update" />
    </div>
  );
}
